/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 注文種別（運賃）
 * @export
 * @enum {number}
 */
export enum FareTypeEnum {
    /** メーター運賃 */
    METER = 0,
    /** 事前確定運賃 */
    PRE_FIXED = 1,
    /** 定額運賃 */
    FLAT = 2
}

/**
 * 注文種別（運賃） の Union 型
 * @export
 * @typedef FareType
 */
export type FareType =
  typeof FareTypeEnum[keyof typeof FareTypeEnum];

/**
 * 注文種別（運賃） のラベルマップ
 * @export
 */
export const FareTypeLabels = {
    /**
     * 数値キー: FareTypeEnum.METER
     * 名前キー:  METER
     */
    [FareTypeEnum.METER]: 'メーター運賃',
    METER:                             'メーター運賃',
    /**
     * 数値キー: FareTypeEnum.PRE_FIXED
     * 名前キー:  PRE_FIXED
     */
    [FareTypeEnum.PRE_FIXED]: '事前確定運賃',
    PRE_FIXED:                             '事前確定運賃',
    /**
     * 数値キー: FareTypeEnum.FLAT
     * 名前キー:  FLAT
     */
    [FareTypeEnum.FLAT]: '定額運賃',
    FLAT:                             '定額運賃',
} as const;

/**
 * 注文種別（運賃） のラベル Union 型
 * @export
 * @typedef FareTypeLabel
 */
export type FareTypeLabel =
  typeof FareTypeLabels[keyof typeof FareTypeLabels];

/**
 * 注文種別（運賃） のラベル取得関数
 * @export
 * @param { FareType } value - 列挙体の値
 * @returns { FareTypeLabel } ラベル文字列
 */
export function getFareTypeLabel(
  value: FareType
): FareTypeLabel {
  return FareTypeLabels[value];
}

/**
 * 注文種別（運賃） のラベル配列を取得する関数
 * @export
 * @param { FareType[] } values - 列挙体の値配列
 * @returns { FareTypeLabel[] } ラベル文字列配列
 */
export function getFareTypeLabels(values: FareType[]): FareTypeLabel[] {
  return values.map((value) => getFareTypeLabel(value));
}

/**
 * 注文種別（運賃） のラベル配列
 * @export
 */
export const FareTypeLabelList = [
  'メーター運賃','事前確定運賃','定額運賃',
] as const;

